module.exports = "/_next/static/images/Hero-3008c1a1e1fb2540172a8a87dca94f25.webp";